module.exports = __webpack_public_path__ + "static/media/wgs-logo.0caed639.png";